import { BaseWebComponentDataProviderFactory } from '../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../../webcomponents.constants';
import { NetworkV2AppNirvanaDataProvider } from '../dataProvider/NetworkV2AppNirvanaDataProvider';

export class NetworkV2AppDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, NetworkV2AppNirvanaDataProvider);
  }
}
